export default [
	{
		lat: 50.0720553,
		lng: 14.3999142,
		city: 'CZ Praha',
		title: 'Praha Smíchov'
	},
	{
		lat: 50.08963,
		lng: 14.4346142,
		city: 'CZ Praha',
		title: 'Praha Florenc'
	},
	{
		lat: 50.0728875,
		lng: 14.5425414,
		city: 'CZ Praha',
		title: 'Praha Europark'
	},
	{
		lat: 49.19288,
		lng: 16.6077667,
		city: 'CZ Brno',
		title: 'Iconic'
	},
	{
		lat: 49.1777114,
		lng: 16.5668564,
		city: 'CZ Brno',
		title: 'Campus Square'
	},
	{
		lat: 49.0850331,
		lng: 16.5781611,
		city: 'CZ Rajhrad',
		title: 'map.branches.distribution',
		distribution: true
	},
	{
		lat: 49.1960983,
		lng: 16.6064931,
		city: 'CZ Brno',
		title: 'Česká'
	},
	{
		lat: 49.8320464,
		lng: 18.2879161,
		city: 'CZ Ostrava',
		title: 'Nová Karolina Park'
	},
	{
		lat: 48.2430417,
		lng: 16.4339053,
		city: 'AT Vídeň',
		title: 'Donau Zentrum'
	},
	{
		lat: 52.25723,
		lng: 20.9845736,
		city: 'PL Warszawa',
		title: 'Arkadia'
	},
	{
		lat: 52.2128572,
		lng: 20.9558486,
		city: 'PL Warszawa',
		title: 'Blue City'
	},
	{
		lat: 52.2304861,
		lng: 20.9874264,
		city: 'PL Warszawa',
		title: 'Prosta'
	},
	{
		lat: 50.0757214,
		lng: 19.9421039,
		city: 'PL Kraków',
		title: 'Kamienna'
	},
	{
		lat: 50.0279769,
		lng: 19.9507208,
		city: 'PL Kraków',
		title: 'Bonarka'
	},
	{
		lat: 52.3965164,
		lng: 16.9554272,
		city: 'PL Poznań',
		title: 'Poznanna'
	},
	{
		lat: 51.1125753,
		lng: 17.0593128,
		city: 'PL Wroclaw',
		title: 'Plac Grunwaldzki'
	},
	{
		lat: 50.2588717,
		lng: 19.0169114,
		city: 'PL Katowice',
		title: 'Galerie Katowicka'
	},
	{
		lat: 54.356435,
		lng: 18.6489919,
		city: 'PL Gdańsk',
		title: 'Galeria Madison'
	},
	{
		lat: 51.77922,
		lng: 19.4449278,
		city: 'PL Lódz',
		title: 'Manufaktura'
	},
	{
		lat: 48.7178369,
		lng: 21.2634267,
		city: 'SK Košice',
		title: 'Aupark'
	},
	{
		lat: 48.1570203,
		lng: 17.1295017,
		city: 'SK Bratislava',
		title: 'Bratislava Central'
	},
	{
		lat: 47.4759597,
		lng: 19.0502067,
		city: 'HU Budapest',
		title: 'Bercsényi'
	},
	{
		lat: 47.4984953,
		lng: 19.0918628,
		city: 'HU Budapest',
		title: 'Arena Mall'
	},
	{
		lat: 44.4421772,
		lng: 26.1521378,
		city: 'RO Bukurest',
		title: 'Mega Mall'
	},
	{
		lat: 44.4779828,
		lng: 26.1035181,
		city: 'RO Bukurest',
		title: 'Promenada Mall'
	},
	{
		lat: 44.4748169,
		lng: 25.9367106,
		city: 'RO Bukurest',
		title: 'map.branches.distribution',
		distribution: true
	},
	{
		lat: 42.6578731,
		lng: 23.314735,
		city: 'BG Sofia',
		title: 'Paradise Center'
	},
	{
		lat: 50.4323381,
		lng: 30.5156594,
		city: 'UA Kiev',
		title: 'Tts Olimpiysʹkyy'
	}
]
